import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-attr-shape-08",
  "use": "icon-attr-shape-08-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-attr-shape-08\"><rect width=\"22\" height=\"22\" x=\"5\" y=\"5\" rx=\"4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol